import { useState } from "react";

import { getConfig } from "site-config";
import { fetchJSON } from "lib/fetch";

import { TAPIResponse } from "../../types";
import { API_STATES } from "../../helpers";

export type TSmartOrderDetails = {
    week_of_supply: string;
    suggested_order_qty: string;
    color: string;
    city: string;
    merchant_name: string;
    upc: string;
    brand_name: string;
    product_name: string;
    zip_code: string;
    brand_id: string;
    shop_id: number;
    account_id: string;
    product_id: string;
    style_number: string;
    size: string;
    insight_date: { value: string };
    season: string;
    id: string;
    state: string;
    ls_customer_id: string;
    current_qoh: string;
};

export type TFetchSmartOrderDetailsResponse = TAPIResponse<TSmartOrderDetails[], string> & {
    fetchSmartOrderDetailsById: (smartOrderId: string) => void;
};

export const useFetchSmartOrderDetails = (): TFetchSmartOrderDetailsResponse => {
    const { api } = getConfig();

    const [state, setState] = useState<TFetchSmartOrderDetailsResponse>({
        ...API_STATES.default,
        fetchSmartOrderDetailsById: undefined,
    });

    const fetchSmartOrderDetailsById = (smartOrderId) => {
        APIStates.pending();

        fetchJSON<TSmartOrderDetails[]>(`${api}/api/v3.0/smart-orders/${smartOrderId}`, {
            method: "GET",
        })
            .then((data) => {
                APIStates.success(data);
            })
            .catch((error) => {
                APIStates.error(error);
            });
    };

    const APIStates = API_STATES.getStates(setState);

    return {
        ...state,
        fetchSmartOrderDetailsById,
    };
};
